import type { ProductQualityMetric } from "../../types/api";

export const getTotalFields = (product: ProductQualityMetric): number => {
    return [
      "title",
      "description_html",
      "category_name",
      "category_full_name",
      "product_type",
      "tags",
      "seo_title",
      "seo_description",
      ...(product.images_objects?.map((_, i) => `image_alt_${i}`) || []),
    ].length;
  };